module.exports = __webpack_public_path__ + "media/fonts/MatterSQ-SemiBold-8db83091811e6cf04535514b7a831bf7.ttf";